import React from "react";
import ReactGuideContent from "./react.mdx";

const ReactGuide: React.FC = () => <ReactGuideContent />;

export default ReactGuide;
